import { Injectable, Output, EventEmitter } from '@angular/core';
import { COOKIE_DOMAIN, COOKIE_PATH, transliterate } from './lib/helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { CookieService } from 'ngx-cookie';
import { RestService } from './lib/RestService';
import { TargetFile } from './lib/TargetFile';
const metaphone = require('metaphone');

export class FilterReference {
  _id: string;
  name: string;
  code: string;
  image?: TargetFile;
  keywords: string[];
  metaphone?: string[];
  active?: boolean;
}

@Injectable()
export class FilterService extends RestService {
  allActivities: FilterReference[] = [];
  allTargetAudiences: FilterReference[] = [];
  activities: FilterReference[] = [];
  targetAudiences: FilterReference[] = [];
  activeTargetAudience: FilterReference;
  activeActivity: FilterReference;
  afterFilterList: Function[] = [];
  @Output() changeActive = new EventEmitter<any>();

  private apiUrl = `${environment.apiUrl}target/`;

  constructor(
    private http: HttpClient,
    private cookie: CookieService,
  ) {
    super();

    this.getData('target');
    this.getData('activity');
  }

  public async getData(type: string) {
    const source = (type === 'target') ? 'Audience' : 'Object';

    try {
      const data = await this.http.get<FilterReference[]>(`${this.apiUrl}${source}?sort=sort`).toPromise();
      this.normalize(data, type);
      const active = this.cookie.get(type);
      if (active) {
        const collection = (type === 'target') ? this.allTargetAudiences : this.allActivities;
        const item = collection.find((i) => i._id === active);
        if (item) this.setActiveFilter(item, type);
      }
    } catch (e) {
      this.handleError(e);
    }
  }

  metaIndex(i: FilterReference) {
    i.metaphone = [];
    i.metaphone.push(metaphone(transliterate(i.name)));
    // if (i.keywords && i.keywords.length > 0) {
    //   let keys = i.keywords.map((k: any) => metaphone(transliterate(k.name)));
    //   i.metaphone.push(...keys);
    // }
    return i;
  }

  normalize(data: FilterReference[], type: string): FilterReference[]|Error {
    if (['target', 'activity'].indexOf(type) === -1) {
      return new Error('Argument "type" must be "target" or "activity"');
    }

    if (type === 'target') {
      this.allTargetAudiences = data.map((i: FilterReference) => this.metaIndex(i));
    } else {
      this.allActivities = data.map((i: FilterReference) => this.metaIndex(i));
    }

    this.filterList('', type);
    return type === 'target' ? this.targetAudiences : this.activities;
  }

  filterList(value: string, type: string) {
    if (['target', 'activity'].indexOf(type) === -1) {
      return console.error(new Error('Argument "type" must be "target" or "activity"'));
    }

    let list: FilterReference[] = [];
    const all = (type === 'target') ? this.allTargetAudiences : this.allActivities;

    // Generate new list
    if (value) {
      value = metaphone(transliterate(value));
      list = all.filter((i) => {
        const meta = i.metaphone.filter((m) => m.includes(value));
        return meta.length > 0;
      });
    } else {
      list = all.map((i) => i);
    }

    // Update list
    if (type === 'target') this.targetAudiences = list; else this.activities = list;

    // Event callback
    this.afterFilterList.forEach((f) => f());
  }

  setActiveFilter(item: FilterReference, type: string) {
    if (['target', 'activity'].indexOf(type) === -1) {
      return console.error(new Error('Argument "type" must be "target" or "activity"'));
    }

    const list = (type === 'target') ? this.allTargetAudiences : this.allActivities;
    for (const i of list) i.active = false;
    const active = list.find((i) => i._id === item._id);
    active.active = true;

    if (type === 'target') this.activeTargetAudience = active; else this.activeActivity = active;
    this.cookie.put(type, active._id, {
      expires: new Date(Date.now() + (10 * 24 * 60 * 60 * 1000)),
      path: COOKIE_PATH,
      domain: COOKIE_DOMAIN
    });
    this.changeActive.emit(active);
  }

  clearFilter(type: string) {
    if (['target', 'activity'].indexOf(type) === -1) {
      return console.error(new Error('Argument "type" must be "target" or "activity"'));
    }

    const list = type === 'target' ? this.allTargetAudiences : this.allActivities;
    for (const i of list) i.active = null;
    if (type === 'target') this.activeTargetAudience = null; else this.activeActivity = null;
    this.cookie.remove(type, { path: COOKIE_PATH, domain: COOKIE_DOMAIN });
    this.changeActive.emit(null);
  }
}
